"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var CidrToMask_1 = require("./CidrToMask");
function numberHosts(subnet, inclusive) {
    var addresses = Math.pow(2, 32 - CidrToMask_1.cidrToMask(subnet));
    return inclusive ? addresses : addresses - 2;
}
exports.numberHosts = numberHosts;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiTnVtYmVySG9zdHMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJOdW1iZXJIb3N0cy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOztBQUFBLDJDQUF5QztBQUV6QyxxQkFBNkIsTUFBYyxFQUFFLFNBQWtCO0lBQzdELElBQUksU0FBUyxHQUFHLElBQUksQ0FBQyxHQUFHLENBQUMsQ0FBQyxFQUFFLEVBQUUsR0FBRyx1QkFBVSxDQUFDLE1BQU0sQ0FBQyxDQUFDLENBQUE7SUFDcEQsTUFBTSxDQUFDLFNBQVMsQ0FBQyxDQUFDLENBQUMsU0FBUyxDQUFDLENBQUMsQ0FBQyxTQUFTLEdBQUcsQ0FBQyxDQUFBO0FBQzlDLENBQUM7QUFIRCxrQ0FHQyJ9


//////////////////
// WEBPACK FOOTER
// ./src/NumberHosts.ts
// module id = 6
// module chunks = 0